import React from 'react';
import { GiftIcon } from 'lucide-react';
export function Bonuses() {
  return <section className="bg-forest py-10 md:py-14" data-id="element-19">
      <div className="max-w-5xl mx-auto px-5 text-center" data-id="element-20">
        <div className="inline-flex items-center gap-2 bg-white/10 text-white px-4 py-2 rounded-full text-sm font-medium mb-4" data-id="element-21">
          <GiftIcon className="w-4 h-4" data-id="element-22" />
          <span data-id="element-23">18 BONOS INCLUIDOS HOY</span>
        </div>

        <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-24">
          Recibes todo el pack completo
        </h2>
        <p className="text-white/70 mb-8" data-id="element-25">
          +450 recetas, +15 ebooks especializados y bonos exclusivos
        </p>

        <div className="bg-white rounded-2xl p-3 md:p-5 mb-4 shadow-2xl" data-id="element-26">
          <img src="https://cdn.magicpatterns.com/uploads/7TAfYKDu5k6KuUptQaXzHp/47588502-1935-4997-966b-8374b9fa662e.png" alt="+450 Recetas Saludables para mascotas — 18 bonos incluidos" className="w-full rounded-xl" data-id="element-27" />
        </div>

        <p className="text-white font-semibold text-base md:text-lg mb-8" data-id="element-28">
          🎁 Todos los ebooks y bonos son{' '}
          <span className="underline" data-id="element-29">de regalo</span> con tu compra hoy
        </p>

        <div className="flex items-baseline justify-center gap-3 mb-6" data-id="element-30">
          <span className="text-white/60 line-through text-xl" data-id="element-31">$50.000</span>
          <span className="text-5xl md:text-6xl font-bold text-white" data-id="element-32">
            $19.990
          </span>
        </div>

        <a href="https://impulsodigital.vip/cart/44794622902358:1" className="inline-block bg-white text-forest px-10 py-5 rounded-lg text-lg font-bold hover:bg-gray-100 transition-colors shadow-xl" data-id="element-33">
          QUIERO ACCESO YA
        </a>

        <p className="text-white/60 text-sm mt-4" data-id="element-34">
          Garantía de 7 días · Acceso inmediato
        </p>
      </div>
    </section>;
}